import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaShoppingBag } from "react-icons/fa";
import { useCarrinho } from "../context/CarrinhoContext";
import { formatarPreco } from "../utils/preco";
import "../css/BarraCarrinho.css";

// Barra fixa acima do rodapé com o resumo do carrinho; "pulsa" quando algo é adicionado.
const BarraCarrinho = () => {
  const { carrinho, calcularQuantidadeTotal, calcularTotal } = useCarrinho();
  const navigate = useNavigate();
  const quantidade = calcularQuantidadeTotal();
  const anterior = useRef(quantidade);
  const [pulso, setPulso] = useState(false);

  useEffect(() => {
    if (quantidade > anterior.current) {
      setPulso(true);
      const t = setTimeout(() => setPulso(false), 450);
      anterior.current = quantidade;
      return () => clearTimeout(t);
    }
    anterior.current = quantidade;
    return undefined;
  }, [quantidade]);

  if (carrinho.length === 0) return null;

  return (
    <div className="barra-carrinho-area">
      <button
        type="button"
        className={`barra-carrinho${pulso ? " barra-carrinho--pulso" : ""}`}
        onClick={() => navigate("/carrinho")}
      >
        <span className="barra-carrinho__icone" aria-hidden="true">
          <FaShoppingBag />
          <span className="barra-carrinho__contador">{quantidade}</span>
        </span>
        <span className="barra-carrinho__texto">Ver carrinho</span>
        <span className="barra-carrinho__total">{formatarPreco(calcularTotal())}</span>
      </button>
      <span className="gm-sr" aria-live="polite">
        {quantidade} {quantidade === 1 ? "item" : "itens"} no carrinho
      </span>
    </div>
  );
};

export default BarraCarrinho;
